module.exports = __webpack_public_path__ + "img/icon_instagram_trash.b208844b.svg";